import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth";
import user from "./modules/user";
import brand from "./modules/brand";
import relation from "./modules/relation";
import product from "./modules/product";

import order from "./modules/order";
import distributor from "./modules/distributor";

import paymentMethod from "./modules/paymentMethod";

import cashier from "./modules/cashier";
import customer from "./modules/customer";
import credit from "./modules/credit";
import purchase from "./modules/purchase";
import subcategory from "./modules/subcategory";
import offer from "./modules/offer";
import print from "./modules/print";
import bill from "./modules/bill";
import unit from "./modules/unit";
import packaging from "./modules/packaging";
import ean from "./modules/ean";
import withdrawal from "./modules/withdrawal";
import supply from "./modules/supply"
import exchange from "./modules/exchange"
import voucher from "./modules/voucher"
import payment from "./modules/payment"

import stocklosses from "./modules/stocklosses"
import pos from "./modules/pos";
import productionSuggestion from "./modules/productionSuggestion";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        user,
        brand,
        relation,
        product,
        order,
        distributor,
        paymentMethod,
        cashier,
        customer,
        credit,
        purchase,
        subcategory,
        offer,
        print,
        bill,
        unit,
        packaging,
        ean,
        withdrawal,
        supply,
        exchange,
        voucher,
        payment,
        stocklosses,
        pos,
        productionSuggestion
    },

    strict: true
});
